import { Capacitor } from '@capacitor/core';

/** iOS/Android WebView では programmatic `<a download>` が効かない */
export function shouldUseShareForFileDownload(): boolean {
  try {
    if (Capacitor.isNativePlatform()) return true;
  } catch {
    // Capacitor 未読込
  }
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

function triggerAnchorDownload(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/** モバイルは共有シート、デスクトップは従来のダウンロード。成功時 true */
export async function shareOrDownloadBlob(blob: Blob, fileName: string): Promise<boolean> {
  if (shouldUseShareForFileDownload() && typeof navigator.share === 'function') {
    const file = new File([blob], fileName, {
      type: blob.type || 'application/octet-stream',
    });
    const shareData: ShareData = { files: [file] };
    if (navigator.canShare && !navigator.canShare(shareData)) {
      return false;
    }
    try {
      await navigator.share(shareData);
      return true;
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return true;
      console.error('Web Share file export failed:', error);
      return false;
    }
  }

  triggerAnchorDownload(blob, fileName);
  return true;
}
